import { useState } from "react";
import clsx from "clsx";
import AddHolidayForm from "./AddHolidayForm";
import AllHolidays from "./AllHolidays";

type HolidaySidebarProps = {
    open: boolean;
    onClose: () => void;
    onHolidaySuccess: () => void;
};

export default function HolidaySidebar({ open, onClose, onHolidaySuccess }: HolidaySidebarProps) {
    const [activeTab, setActiveTab] = useState<"add" | "all">("add");

    return (
        <>
            {/* Overlay */}
            <div
                onClick={onClose}
                className={clsx(
                    "fixed inset-0 bg-black/50 transition-opacity duration-300",
                    open ? "opacity-100 visible" : "opacity-0 invisible"
                )}
                style={{ zIndex: 100 }}
            />

            {/* Sidebar */}
            <aside
                className={clsx(
                    "fixed top-0 right-0 z-50 h-full bg-white shadow-xl transition-transform duration-300",
                    "w-full sm:w-[420px]", // full on mobile, fixed width on desktop
                    open ? "translate-x-0" : "translate-x-full"
                )}
                style={{ zIndex: 105 }}
            >
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-3 border-b">
                    <h2 className="text-[18px]">Holiday Management</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-800 hover:text-gray-700 text-xl"
                    >
                        ✕
                    </button>
                </div>

                {/* Tabs */}
                <div className="flex border-b px-6">
                    <button
                        onClick={() => setActiveTab("add")}
                        className={clsx(
                            "py-3 px-3.5 font-medium border-b-2 text-[#0A0A0A]",
                            activeTab === "add"
                                ? "border-[#7E57C2]"
                                : "border-transparent text-[#717182]"
                        )}
                    >
                        Add Holiday
                    </button>

                    <button
                        onClick={() => setActiveTab("all")}
                        className={clsx(
                            "py-3 px-3.5 font-medium border-b-2 text-[#0A0A0A]",
                            activeTab === "all"
                                ? "border-[#7E57C2]"
                                : "border-transparent text-[#717182]"
                        )}
                    >
                        All Holidays
                    </button>
                </div>

                {/* Content */}
                <div className="overflow-y-auto h-[calc(100%-120px)]">
                    {activeTab === "add" && (
                        <AddHolidayForm
                            onSuccess={() => {
                                onHolidaySuccess();   // refetch calendar
                                onClose();            // close sidebar
                                setActiveTab("all");  // optional UX
                            }}
                        />
                    )}

                    {activeTab === "all" &&
                        <AllHolidays
                            onSuccess={() => {
                                onHolidaySuccess();   // refetch calendar
                                onClose();            // close sidebar
                                setActiveTab("all");  // optional UX
                            }}
                        />}
                </div>
            </aside>
        </>
    );
}
